/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 4/11/2019.
 */

import React from 'react'

class StatusIcon extends React.PureComponent {

    render() {
        const {color} = this.props
        let className = "status-icon "
        if (color) {
            className += color
        }
        return <div className={className}></div>
    }
}

export default StatusIcon